<template lang="pug">
  v-layout(row)
    v-flex(xs12 sm6 offset-sm3)
      v-card
        v-toolbar(color="white" flat)
          v-toolbar-title(class="grey--text text--darken-4") Create a package
        v-form
          v-container
            v-layout(row wrap)
              v-flex(xs3)
                v-img(v-if="selectedEvent!=null" :src = "imageSrc")
                
              v-flex(xs9) 
                v-combobox(
                  :items="events"
                  item-text = "eventName"
                  item-value = "id"
                  v-model="selectedEvent"
                  label="Select an event")
            v-text-field(v-model="packageName" label="Package Name") 
            v-text-field(v-model="cost" label="Cost") 
            v-menu(
              ref="menu1"
              :close-on-content-click="false"
              v-model="menu1"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px")
        
              v-text-field(
                slot="activator"
                v-model="dateFormatted"
                label="Package Expiry Date"
                hint="DD/MM/YYYY format"
                disabled
                persistent-hint
                prepend-icon="event")
              v-date-picker(v-model="date" no-title @input="menu1 = false")
            v-menu(
              ref="menu2"
              :close-on-content-click="false"
              v-model="menu2"
              :nudge-right="40"
              :return-value.sync="endTime"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px")

              v-text-field(
                slot="activator"
                v-model="endTime"
                label="Package Expiry Time"
                prepend-icon="access_time"
                :hint = "res"
                readonly)
              v-time-picker(
                v-if="menu2"
                v-model="endTime"
                full-width
                @change="$refs.menu2.save(endTime); ")
            list-builder.py-2(title = "Package Contents" :items="items" inputLabel="Enter the contents" @contentChanged="updateContents")
            v-textarea(
              name="description"
              v-model="description"
              label="Description"
              hint="Sell the concept of the package")
            image-upload
            v-btn(@click="save") Save

</template>
<script>
//Creates a package that is stored inside of an event

const ListBuilder = () => import('../../components/ListBuilder')
const ImageUpload = () => import('../../components/ImageUpload')
export default {
  name: 'CreatePackage',
  components: {ImageUpload, ListBuilder},
  data: () => ({
    selectedEvent:null,
    description:'' ,
    cost:'',
    packageName:'',
    menu1: false,
    menu2: false,
    dateFormatted:'',
    endTime:'',
    date:'',
    res:'',
    items:['item1', 'item2'],
    contents:null
  }),
  watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      }
    },
  created(){
    if (Object.keys(this.$store.state.events).length==0 ){
      this.$store.dispatch('getEvents')
    }
  },
  computed:{
    imageSrc(){return this.$store.state.baseImageURL +"th"+ this.event.imageURL+"?alt=media"},
    event(){
      return this.$store.state.events.find(el=>{return el.id == this.selectedEvent.id})
    },
    events(){
      return this.$store.state.events
    }
  },
  methods:{
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    save(){
      let eventpackage = {
        packageName: this.packageName,
        description: this.description,
        expiryDate: this.dateFormatted,
        expiryTime: this.endTime,
        imageURL: this.$store.state.imageURL,
        location: this.location,
        eventId: this.selectedEvent.id,
        contents: this.contents,
        cost: this.cost
      }
      this.$store.dispatch('savePackage', eventpackage)
    },
    validateTime(){
      if (this.startTime < this.endTime){
        this.res = ""
        this.tcolor = ''
      }else{
        if (this.startTime && this.endTime){
        this.res = "Start time must be earlier than end time"
        this.tcolor = "red accent-1"
        }
      }
    },
    updateContents(contents){
      this.contents = contents
    }
  }

}
</script>


